import type { PublicRouletteDisplay, PublicRoulettePrize } from '@/lib/landing-roulette'

export type LuckyWheelItem = {
  posicao: number
  premio: {
    tipo: PublicRoulettePrize['prize_type']
    display: PublicRoulettePrize['display']
  } | null
  hash: string
  angulo: number
}

export function buildLuckyWheelItems(
  display: PublicRouletteDisplay,
  hashPrefix: string
): LuckyWheelItem[] {
  const positions = display.positions
  const prizes = display.prizes

  return Array.from({ length: positions }, (_, index) => {
    const prize = prizes.find((item) => item.position === index + 1) ?? null

    return {
      posicao: index,
      premio: prize
        ? {
            tipo: prize.prize_type,
            display: prize.display,
          }
        : null,
      hash: `${hashPrefix}-${index + 1}`,
      angulo: (index * 360) / positions,
    }
  })
}
